module.exports = __webpack_public_path__ + "img/0029.189846b8.jpg";